"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPhoneNumber = exports.JobRegExValidators = exports.calculatePriceSplit = exports.normalizeServiceList = exports.NormalizeServiceLookup = exports.PREPAYMENT_DEDUCTION_SERVICE_TYPE = exports.PREPAYMENT_SERVICE_TYPE = exports.WITHOUT_LAX_VALIDATION = exports.WITH_LAX_VALIDATION = void 0;
exports.WITH_LAX_VALIDATION = 'yes';
exports.WITHOUT_LAX_VALIDATION = 'no';
exports.PREPAYMENT_SERVICE_TYPE = '900.Prepayment';
exports.PREPAYMENT_DEDUCTION_SERVICE_TYPE = '901.DeductionOfPrepayment';
var NormalizeServiceLookup;
(function (NormalizeServiceLookup) {
    NormalizeServiceLookup["SFID"] = "sfid";
    NormalizeServiceLookup["NAME_GENERATED"] = "name_generated";
})(NormalizeServiceLookup = exports.NormalizeServiceLookup || (exports.NormalizeServiceLookup = {}));
function normalizeServiceList(serviceDefinitions, services, lookup = NormalizeServiceLookup.SFID) {
    const definitions = {};
    for (const definition of serviceDefinitions) {
        definitions[definition[lookup]] = definition;
    }
    let only_in_combination_with_lookup = null;
    switch (lookup) {
        case NormalizeServiceLookup.SFID:
            only_in_combination_with_lookup = 'only_in_combination_with';
            break;
        case NormalizeServiceLookup.NAME_GENERATED:
            only_in_combination_with_lookup =
                'name_generated_only_in_combination_with';
            break;
        default:
            only_in_combination_with_lookup = 'only_in_combination_with';
            break;
    }
    const normalizedServiceQuantities = new Map();
    const valueEntries = {};
    const servicesByIdentifier = {};
    const automaticallyInsertedServices = [];
    let deduplicate = true;
    for (const service of services) {
        servicesByIdentifier[service.service] = service;
        normalizedServiceQuantities.set(service.service, service.quantity +
            (normalizedServiceQuantities.get(service.service) || 0));
        if (!(service.service in valueEntries) && service.value_entry) {
            valueEntries[service.service] = service.value_entry;
        }
    }
    for (const service of services) {
        const addRequiredService = (serviceDefinition) => {
            if (!serviceDefinition) {
                console.error(`Missing service definition for ${service.service} | ${service.name}`);
                return;
            }
            if (!serviceDefinition[only_in_combination_with_lookup]) {
                return;
            }
            for (const onlyInCombinationWith of serviceDefinition[only_in_combination_with_lookup]) {
                if (!normalizedServiceQuantities.get(onlyInCombinationWith.service)) {
                    const qty = normalizedServiceQuantities.get(service.service) *
                        onlyInCombinationWith.quantity;
                    normalizedServiceQuantities.set(onlyInCombinationWith.service, qty);
                    automaticallyInsertedServices.push({
                        service: onlyInCombinationWith.service,
                        quantity: qty,
                        project_sequence: service.project_sequence,
                    });
                }
                addRequiredService(definitions[onlyInCombinationWith.service]);
            }
        };
        addRequiredService(definitions[service.service]);
    }
    const newServices = [];
    for (const svc of services.concat(automaticallyInsertedServices)) {
        const serviceIdentifier = svc.service;
        const serviceDefinition = definitions[serviceIdentifier];
        if (!serviceDefinition)
            continue;
        const service = {};
        service.service = serviceDefinition[lookup];
        service.project_sequence = svc.project_sequence;
        if (serviceDefinition.one_or_more === 'one') {
            if (!normalizedServiceQuantities.has(serviceIdentifier)) {
                continue;
            }
            service.quantity = 1;
        }
        else {
            let quantity;
            if (deduplicate) {
                if (!normalizedServiceQuantities.has(serviceIdentifier)) {
                    continue;
                }
                quantity = normalizedServiceQuantities.get(serviceIdentifier);
            }
            else {
                quantity = svc.quantity;
            }
            if (serviceDefinition.minimum_quantity &&
                quantity < serviceDefinition.minimum_quantity) {
                quantity = serviceDefinition.minimum_quantity;
            }
            if (serviceDefinition.maximum_quantity &&
                quantity > serviceDefinition.maximum_quantity) {
                quantity = serviceDefinition.maximum_quantity;
            }
            service.quantity = quantity;
        }
        if (serviceIdentifier in valueEntries) {
            service.value_entry = valueEntries[serviceIdentifier];
        }
        normalizedServiceQuantities.delete(serviceIdentifier);
        newServices.push(service);
    }
    return newServices;
}
exports.normalizeServiceList = normalizeServiceList;
function calculatePriceSplit(parentServiceType, totalPrice, childServices) {
    if (Number(totalPrice) == 0 ||
        !parentServiceType ||
        [exports.PREPAYMENT_SERVICE_TYPE, exports.PREPAYMENT_DEDUCTION_SERVICE_TYPE].includes(parentServiceType)) {
        return { labor: 0, products: 0 };
    }
    if (childServices && childServices.length > 0) {
        const totalPurchasePrice = childServices.reduce((acc, { purchasePrice, sellingPrice, quantity }) => acc + (purchasePrice === 0 ? sellingPrice : purchasePrice) * quantity, 0);
        if (!totalPurchasePrice) {
            return handleSpecialParentServiceType(parentServiceType, totalPrice);
        }
        return {
            labor: (totalPrice *
                childServices.reduce((acc, { purchasePrice, sellingPrice, quantity, serviceType }) => acc +
                    calculatePriceSplit(serviceType, purchasePrice === 0 ? sellingPrice : purchasePrice).labor *
                        quantity, 0)) /
                totalPurchasePrice,
            products: (totalPrice *
                childServices.reduce((acc, { purchasePrice, sellingPrice, quantity, serviceType }) => acc +
                    calculatePriceSplit(serviceType, purchasePrice === 0 ? sellingPrice : purchasePrice).products *
                        quantity, 0)) /
                totalPurchasePrice,
        };
    }
    return handleSpecialParentServiceType(parentServiceType, totalPrice);
}
exports.calculatePriceSplit = calculatePriceSplit;
function handleSpecialParentServiceType(parentServiceType, totalPrice) {
    if (['170.Material_und_Arbeit', '200.Package'].includes(parentServiceType)) {
        return { labor: totalPrice / 2, products: totalPrice / 2 };
    }
    if (parentServiceType == '090.Materialkosten') {
        return { labor: 0, products: totalPrice };
    }
    return { labor: totalPrice, products: 0 };
}
exports.JobRegExValidators = {
    postalCode: /^(\d{5})\s([^\d]+)/,
    phone: /^[\+0-9][\d\- ]{9,14}$/,
    domain: /@[\w.-]+\.[a-zA-Z]{2,}/,
};
function removeSpecialCharacters(text) {
    return text.replace(/[^\w\s]/gi, '');
}
function formatPhoneNumber(number) {
    number = removeSpecialCharacters(number);
    if (!exports.JobRegExValidators.phone.test(number))
        return '';
    number.replace(/-/g, '').replace(/^0049|^00/, '+49');
    if (number.startsWith('+')) {
        return number;
    }
    if (number.startsWith('0')) {
        return '+49' + number.slice(1);
    }
    return '+49' + number;
}
exports.formatPhoneNumber = formatPhoneNumber;
//# sourceMappingURL=util.js.map